function show_popup(url){
  
  var xmlhttp = new XMLHttpRequest();
  
  xmlhttp.open("GET",url,true);
  
  xmlhttp.onreadystatechange = function(){

    if(xmlhttp.readyState == 4 && xmlhttp.status==200)
    {
		Swal.fire({
            title:'<small></small>',
            html: xmlhttp.responseText
          })
           
      return data;
    }
  }
  xmlhttp.send(null);
}